var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","justify-content":"center","align-items":"center","display":"flex"},attrs:{"id":"app"}})}
var staticRenderFns = []

export { render, staticRenderFns }